import ko from "knockout";

import * as formatMoney from "../utils/formatMoney";
import logger from "../logger";

import { MaybeObservable } from "../interfaces/MaybeObservable";

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface KnockoutPunchesFilters {
        moneyFormat(valueObs: MaybeObservable<number>): string;
        currencyFormat(valueObs: MaybeObservable<number>): string;
    }
}

ko.filters.moneyFormat = function (valueObs: MaybeObservable<number>) {
    const rawValue = ko.unwrap(valueObs);
    try {
        return formatMoney.numberToMoney(rawValue);
    } catch (e) {
        logger.error("money filter error:", e);
        return String(rawValue); // Return the original value as a string if transformation fails
    }
};

ko.filters.currencyFormat = ko.filters.moneyFormat; // Alias
